import * as types from '../types';
import { IJournalEntriesApi } from '../contracts';
import { HttpApi } from './HttpApi';

// Backend mounts the GL router at /gl (GET /gl/journal-entries).
const BASE = '/gl/journal-entries';

export class JournalEntriesHttpApi extends HttpApi implements IJournalEntriesApi {
  async listJournalEntries(
    page = 1,
    limit = 20,
    filters: types.JournalEntryListFilters = {}
  ): Promise<types.PaginatedResponse<types.JournalEntry>> {
    // Blank filters are left out: the server rejects e.g. sourceType='' (400 INVALID_FILTER).
    const params: Record<string, string | number> = { page, limit };
    (['startDate', 'endDate', 'sourceType', 'accountId'] as const).forEach((key) => {
      const value = filters[key];
      if (value) params[key] = value;
    });
    const response = await this.http.get<types.PaginatedResponse<types.JournalEntry>>(BASE, { params });
    return response.data;
  }

  async getJournalEntry(id: string): Promise<types.JournalEntry> {
    const response = await this.http.get<types.APIResponse<types.JournalEntry>>(`${BASE}/${encodeURIComponent(id)}`);
    return response.data.data;
  }

  async createJournalEntry(data: types.CreateJournalEntryRequest): Promise<types.JournalEntry> {
    const response = await this.http.post<types.APIResponse<types.JournalEntry>>(BASE, data);
    return response.data.data;
  }

  async reverseJournalEntry(id: string, memo?: string): Promise<types.JournalEntry> {
    const trimmed = memo?.trim();
    const response = await this.http.post<types.APIResponse<types.JournalEntry>>(
      `${BASE}/${encodeURIComponent(id)}/reverse`,
      trimmed ? { memo: trimmed } : {}
    );
    return response.data.data;
  }
}
